import { MyMonitoringLogoOnlyColor } from '../common/logos/MyMonitoringLogoOnlyColor'
import './styles.scss'

export const SuspenseFallbackMyMonitoring = () => (
  <div className='bg-bg flex h-screen w-full items-center justify-center px-4'>
    <div className='relative'>
      <div className='animate-shimmer absolute top-0 left-0 flex items-center justify-center' />
      <MyMonitoringLogoOnlyColor classes='w-[60px]' />
    </div>
  </div>
)
